import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'bar47',
  Description: "<p>Here's all the online content included with your <strong>Biology Revision Guide</strong>.</p>",
  Credits:
    'Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2025. All rights reserved.\n',
};
